// extracted by LIB_CSS_EXTRACT_LOADER
import "./table-skeleton_module.css"
export default {"container":"container-oHhKZN","header":"header-E48oWr","headerCell":"headerCell-TX8s6a","row":"row-lQRCtQ","cell":"cell-xgtjto"};